import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const AhuGlyph = /*#__PURE__*/createElement("g", {
  id: "ahu"
}, /*#__PURE__*/createElement("path", {
  d: "M66.72 58.91c-5.99-.65-8.46-4.6-9.48-7.39l1.95 1.04c.73.39 1.64.12 2.03-.62.39-.73.12-1.64-.62-2.03l-4.36-2.33c-.49-.26-1.05-.32-1.58-.16-.01 0-.02.01-.03.01-.1.03-.2.07-.29.12-.39.19-.71.49-.91.88L51.1 52.8a1.499 1.499 0 002.64 1.42l.79-1.47c1.35 3.51 4.53 8.34 11.86 9.15.06.01.11.01.17.01a1.506 1.506 0 00.16-3zM33.05 52.8l-2.33-4.37c-.21-.39-.53-.69-.91-.88a1.39 1.39 0 00-.28-.12c-.01 0-.02-.01-.03-.01-.53-.16-1.09-.1-1.58.16l-4.36 2.33c-.73.39-1.01 1.3-.62 2.03s1.3 1.01 2.03.62l1.97-1.05c-1 2.78-3.46 6.74-9.5 7.4-.82.09-1.42.83-1.33 1.65.08.77.73 1.34 1.49 1.34.05 0 .11 0 .16-.01 7.33-.8 10.51-5.63 11.86-9.15l.78 1.47c.27.51.79.79 1.32.79.24 0 .48-.06.71-.18.73-.38 1.01-1.29.62-2.02zM69.51 35.64c-.23-.56-.78-.93-1.39-.93h-8.21V22.53c0-.83-.67-1.5-1.5-1.5H25.83c-.83 0-1.5.67-1.5 1.5v12.18h-8.45a1.498 1.498 0 00-1.05 2.57l7.06 6.94c.28.28.66.43 1.05.43h15.18v-3H23.56l-4.01-3.94h44.9l-4.01 3.94H46.11v3h14.94c.39 0 .77-.16 1.05-.43l7.06-6.94c.44-.43.58-1.07.35-1.64zm-42.18-.93V24.03h29.58v10.68H27.33z"
}), /*#__PURE__*/createElement("path", {
  d: "M47 54.55h-2.89v-14.9h-3.99v14.9h-2.89a1.765 1.765 0 00-1.25 3.01l4.88 4.88c.33.33.78.52 1.25.52s.92-.19 1.25-.52l4.88-4.88c.5-.5.66-1.26.38-1.92A1.73 1.73 0 0047 54.55z"
}));
const Ahu = createSvg({
  name: 'ahu',
  path: AhuGlyph
});

export default Ahu;
export { AhuGlyph };
